/**
 * Cache Bust URL Module
 *
 * Appends a `cb` query param with the current timestamp to the href of any
 * anchor with the `cache-bust-url` class, as well as to the
 * `window.QSS_ROUTE_MISSING_ISSUE` and `window.QSS_ROUTE_NEED_HELP` globals
 * (when present and valid URLs), ensuring the links are not served from cache.
 */

/**
 * Appends a `cb` query param with the current timestamp to a URL string.
 *
 * @param {string} href - The URL to cache-bust.
 * @return {string|null} The cache-busted URL, or null if href is not a valid URL.
 */
export const cacheBustUrl = href => {
	if ( ! href ) {
		return null;
	}

	try {
		const url = new URL( href, window.location.origin ); // phpcs:ignore WordPressVIPMinimum.JS.Window.location
		url.searchParams.set( 'cb', Date.now() );

		return url.href;
	} catch ( e ) {
		return null;
	}
};

const init = () => {
	document.querySelectorAll( 'a.cache-bust-url' ).forEach( link => {
		const bustedhref = cacheBustUrl( link.getAttribute( 'href' ) );

		if ( bustedhref ) {
			link.setAttribute( 'href', bustedhref );
		}
	} );

	[ 'QSS_ROUTE_MISSING_ISSUE', 'QSS_ROUTE_NEED_HELP' ].forEach( key => {
		const bustedhref = cacheBustUrl( window[ key ] );

		if ( bustedhref ) {
			window[ key ] = bustedhref;
		}
	} );
};

// Initialize when DOM is ready.
if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
